export const PropertyDKS = {
  main: {
    parking_spots: 'Parking',
    parking_type: 'Parking type',
    property_type: 'Property type',
    heat_type: 'Heating type',
    style: 'Style',
  },
  sale: {
    condo: {
      ensuite_laundry: 'Ensuite laundry',
    },
    freehold: {

    },
  },
  rent: {
    condo: {
      ensuite_laundry: 'Ensuite laundry',
      water_inc: 'Water included',

    },
    freehold: {
    },
  },
}
